const DashIcon = () => (
  <svg viewBox="0 0 24 2" width="24">
    <line x1="-4" y1="1" x2="28" y2="1" stroke="#999999" strokeDasharray="8 4" />
  </svg>
);

export default DashIcon;
